import api from "./axios";
import type { User } from "./types";
export const userService = {
  getMe: () => api.get<User>("/users/me").then(r => r.data),
  updateIncome: (monthlyIncome: number) => api.patch<User>("/users/me/income", { monthlyIncome }).then(r => r.data),
};
